import $ from 'jquery';
import _ from 'lodash-es';
import getSizedImageURL from '../../../core/INF-getSizedImageURL';

export default (images) => {
  let html = '';

  _.each(images, (image) => {
    const src = getSizedImageURL(image.src, '240x');
    const $img = $(`[data-product-images-seo] img[src="${src}"]`).eq(0).clone();

    html += `
  <div class="ProductImages__thumb" data-product-images-thumb>
  <div class="ProductImages__thumb-container">
    ${$img[0].outerHTML}
  </div>
  </div>`;
  });

  return html;
};